import { render, staticRenderFns } from "./marsModal.vue?vue&type=template&id=2be99cad&"
import script from "./marsModal.vue?vue&type=script&lang=js&"
export * from "./marsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports